<template>
  <div>
    {{ displayedText }}
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true,
    },
    speed: {
      type: Number,
      default: 100, // 默认每字符间隔100毫秒
    },
  },
  data() {
    return {
      currentIndex: 0,
      displayedText: "",
    };
  },
  mounted() {
    this.startTyping();
  },
  methods: {
    async startTyping() {
      for (let i = 0; i < this.text.length; i++) {
        this.displayedText += this.text.charAt(i);
        await this.wait(this.speed);
        this.$nextTick();
      }
    },
    wait(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
  },
};
</script>

<style lang="scss" scoped></style>
